'use strict';
/*
 * Loosly based on http://stackoverflow.com/a/11870341/2108024
 * This causes the model update to only happen after 0.7 sections or when the user leaves the field.
 * This prevents the validation from happening too often or being annoying. In angular 1.3 we would use
 * ngModelOptions, so this is effectively a shim for that.
 */

angular.module('msUtility').directive('modelDelayed', ['$timeout', function ($timeout) {
  return {
    restrict: 'A',
    require: 'ngModel',
    priority: 1,
    link: function link(scope, elm, attr, ngModelCtrl) {
      var timeout;
      elm.unbind('input').unbind('keydown').unbind('change');
      elm.bind('input', function () {
        $timeout.cancel(timeout);
        timeout = $timeout(function () {
          scope.$apply(function () {
            ngModelCtrl.$setViewValue(elm.val());
          });
        }, 2400);
      });
      elm.bind('blur', function () {
        $timeout.cancel(timeout);
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(elm.val());
        });
      });
    }
  };
}]);